import { proxy } from 'valtio'
import { endOfDay, formatISO, startOfDay, subDays } from 'date-fns'
import lodashThrottle from 'lodash/throttle'
import { type ApiCallType } from '../../../../../shared/types/ApiCallType'
import { buildAxiosInstance } from '../../../../../shared/utils/apiUtils'
import { type GlobalTransactionHisType } from '../../../../../shared/types/GlobalTransactionHisType'
import { convertFromCentValue } from '../../../../../shared/utils/formattingUtils'

interface Response {
  data: {
    transactions: GlobalTransactionHisType[]
    pagination: {
      count: number
    }
  } | null
  error: string | null
}

export interface RecentActivitiesProxyType {
  apiCall: ApiCallType
  recentTransactions: GlobalTransactionHisType[]
}

export const recentActivitiesProxy: RecentActivitiesProxyType = proxy({
  apiCall: {
    error: null,
    loading: false
  },
  recentTransactions: []
})

export const throttledFetchRecentActivities = lodashThrottle(fetchRecentActivities, 500, { trailing: false })

export async function fetchRecentActivities (): Promise<void> {
  recentActivitiesProxy.apiCall.loading = true
  recentActivitiesProxy.apiCall.error = null
  try {
    const now = new Date()
    const startDate = subDays(now, 30)
    const response = await buildAxiosInstance().post<Response>('/api/transactions/search', {
      endDate: formatISO(endOfDay(now), { representation: 'complete' }),
      limit: 10,
      offset: 0,
      startDate: formatISO(startOfDay(startDate), { representation: 'complete' })
    })
    const recentT = response.data?.data?.transactions ?? []

    recentT.forEach(txn => {
      txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
    })
    recentActivitiesProxy.recentTransactions = recentT
  } catch (e) {
    if (e instanceof Error) {
      recentActivitiesProxy.apiCall.error = e.message
    }
  } finally {
    recentActivitiesProxy.apiCall.loading = false
  }
}
